import React, { Component, PropTypes } from 'react';
import SignContract from 'common/containers/sign_contract';

export default class SignNDA extends Component {
  componentDidMount() {
    const { fetchContract, project, user } = this.props;

    if (project.nda_required && user.is_creative) {
      fetchContract();
    }
  }

  componentWillUnmount() {
    this.props.clearContract();
  }

  render() {
    const { showing } = this.props;

    if (!showing) {
      return null;
    }

    return <SignContract {...this.props} />;
  }
}

SignNDA.propTypes = {
  fetchContract: PropTypes.func.isRequired,
  clearContract: PropTypes.func.isRequired,
  project: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./project/components/sign_nda.jsx